import React, { Component, PropTypes } from 'react';
import RulerBar from 'components/RulerBar';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import MediaLibraryStore from 'stores/MediaLibrary';
import AppPage from 'components/AppPage';
import MediaLibraryActions from 'actions/MediaLibrary';
import DetailPane from 'components/Widgets/DetailPane';
import {
  Styles,
  List,
  ListItem,
  Toolbar,
  ToolbarGroup,
  ToolbarTitle,
  FontIcon,
  Dialog,
  FlatButton,
  RaisedButton,
  TextField,
  Toggle,
  DatePicker,
  RadioButtonGroup,
  RadioButton
} from 'material-ui';
import Spinner from 'components/Material/Spinner';
import { GridContainer, GridRow, GridCell } from 'components/Grid/Grid';
import Constants from 'Constants';
import Message from 'services/Message';
import VideoPlayer from 'components/Widgets/VideoPlayer';
import ScrollableContainer from 'components/ScrollableContainer';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import * as SvgIcons from 'components/Material/SvgIcons';
import DialogPortal from 'components/DialogPortal';
import { FormattedMessage, FormattedDate } from 'react-intl';

import { addMessages } from 'oxygen-i18n';

addMessages({
  ['en-US']: {
    'Download': 'Download'
  },
  ['sv-SE']: {
    'Download': 'Ladda ner'
  }
});

let {
  ImageAudiotrack,
  AvMovie,
  EditorInsertDriveFile,
  ImageImage,
  ActionAccountBox,
  EditorInsertLink,
  ActionSchedule,
  EditorModeEdit,
  ContentAdd,
  ActionDelete,
  ContentClear,
  ActionLabel
} = SvgIcons;

let { Spacing, Colors } = Styles;

let types = {
  audio: ImageAudiotrack,
  video: AvMovie
};

export default class MediaLibraryDetail extends mixin(
  RefluxMixin,
  Authorizer,
  Component
) {
  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(MediaLibraryStore);
  }

  listenToActions() {
    this.listenToAction(MediaLibraryActions.deleteComplete, file => {
      Message.info(this.context.getIntlMessage('mediaLibrary.removed'));
      if (this.props.onClose) {
        this.props.onClose();
      }
    });
    this.listenToAction(
      MediaLibraryActions.genericError,
      this.onError.bind(this)
    );
  }

  onError(errorMessage) {
    Message.info(errorMessage);
  }

  confirmDelete(file) {
    MediaLibraryActions.delete(file.id);
  }

  deleteFile() {
    this.refs.confirmDialog.show();
  }

  closeDetail() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    let file = this.props.file;

    let confirmActions = [
      { text: 'Cancel' },
      {
        text: this.context.getIntlMessage('mediaLibrary.remove'),
        onTouchTap: this.confirmDelete.bind(this, file),
        ref: 'submit'
      }
    ];

    let coverStyle, thumb;
    let fileType = file.mime.substring(0, file.mime.indexOf('/'));
    if (fileType === 'image') {
      coverStyle = {
        backgroundImage: 'url(' + file.url + ')'
        // backgroundImage: 'url(http://lorempixel.com/144/144/technics)'
      };
      thumb = (
        <div style={{ textAlign: 'center' }}>
          <img src={file.url} style={{ maxWidth: '100%' }} />
        </div>
      );
    } else if (fileType === 'video') {
      let extension = file.url.split('.').pop();
      thumb = (
        <VideoPlayer
          style={{ display: 'inline-block' }}
          sources={[
            { url: file.url, type: 'mp4' },
            { url: file.url, type: 'ogg' }
          ]}
        />
      );
    } else if (types[fileType]) {
      let type = types[fileType];
      thumb = (
        <div
          style={{
            textAlign: 'center',
            height: Spacing.desktopKeylineIncrement * 4
          }}
        >
          <type />
        </div>
      );
    } else {
      <EditorInsertDriveFile />;
      thumb = (
        <div
          style={{
            textAlign: 'center',
            height: Spacing.desktopKeylineIncrement * 4
          }}
        >
          <EditorInsertDriveFile />
        </div>
      );
    }
    const created = file.created && file.created.split(' ').join('T') + 'Z';

    const date = (created && <FormattedDate value={new Date(created)} />) || '';
    let toolbar = (
      <Toolbar>
        <ToolbarGroup float={'left'} key={0}>
          <ToolbarTitle text={this.context.getIntlMessage('File')} />
        </ToolbarGroup>
        <ToolbarGroup float={'right'} key={1}>
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('mediaLibrary.remove')}
            tooltipPosition="bottom-center"
            svgIcon={<ActionDelete />}
            onTouchTap={this.deleteFile.bind(this)}
          />
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('Close')}
            tooltipPosition="bottom-center"
            svgIcon={<ContentClear />}
            onTouchTap={this.closeDetail.bind(this)}
          />
        </ToolbarGroup>
      </Toolbar>
    );
    return (
      <ScrollableContainer
        header={toolbar}
        style={{ backgroundColor: Colors.fullWhite }}
      >
        {thumb}
        <List>
          <ListItem
            disabled={true}
            leftIcon={<ActionLabel />}
            primaryText={file.name}
          />
          <ListItem
            disabled={true}
            leftIcon={<ActionSchedule />}
            primaryText={date}
          />
          <ListItem
            disabled={true}
            leftIcon={<EditorInsertLink />}
            primaryText={ <a href={file.mime.includes('video') ? file.url + file.mime.replace('video/', '.') : file.url} download>{this.context.getIntlMessage('Download')}</a> }
          />
          <ListItem
            disabled={true}
            leftIcon={<ActionAccountBox />}
            primaryText={localStorage.displayName}
          />
        </List>
        <DialogPortal>
          <Dialog
            ref="confirmDialog"
            title={this.context.getIntlMessage('mediaLibrary.remove')}
            actions={confirmActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            <FormattedMessage
              message={this.context.getIntlMessage(
                'mediaLibrary.removeConfirm'
              )}
              file={file.name}
            />
          </Dialog>
        </DialogPortal>
      </ScrollableContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/MediaLibrary/Detail.js